// src/pages/BlogList.js
import React, { useEffect, useState } from 'react';
import client from '../components/sanityClient';
import BlogPostCard from '../components/BlogPostCard';

const BlogList = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const query = `*[_type == "post"]{
      title,
      publishedAt,
      slug
    }`;

    client.fetch(query)
      .then((data) => setPosts(data))
      .catch(console.error);
  }, []);

  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto', padding: '1rem' }}>
      <h1 style={{ marginBottom: '1rem', color: '#333' }}>Blog Posts</h1>
      {posts.map((post) => (
        <BlogPostCard key={post.slug.current} post={post} />
      ))}
    </div>
  );
};

export default BlogList;
